<template>
    <div style="margin: 0px 10px">
        <div style="display: flex;align-items: center;">
            <el-image style="height: 50px;width: 50px" :src="chooseItem.img"  :lazy='true'>
                <div slot="error" class="image-slot"><i class="el-icon-picture-outline" style="font-size:50px"></i></div>
            </el-image>
            <p align="left" style="margin-left: 10px;margin-top: auto">
                <b>{{chooseItem.crafite_name}}</b>(version:{{version}})
            </p>
        </div>
        <div>
            <div style="float: left;margin-top: 6px;margin-bottom: 6px;margin-left: 10px;">
                <span><b>{{total}}</b> Charters</span>
                <span style="alignment: left">
                    <b>Language:</b>
                    <button class="activation" ref="english" @click="toEnglish()">English</button>
                    <button class="inactive" ref="spanish" @click="toSpanish()">Spanish</button>
                </span>
            </div>
            <div style="float: right;margin-top: 6px;margin-bottom: 6px">
                <el-button class="el-button--small el-button--primary" @click="uploadVisible=true">Bulk Upload</el-button>
                <el-button class="el-button--small el-button--primary" @click="toAdd('craftiesContentAdd')">New Charter</el-button>
                <el-button class="el-button--small el-button--default" @click="$router.go(-1)">Back</el-button>
            </div>
        </div>
        <div>
            <el-table v-if="flag"  v-tb-height="{bottom:10,self:this}" :height="height" border :data="list" v-loadmore="loadMore" empty-text="Temporarily no data">
                <el-table-column min-width="50px" prop="show_charter_no" label="No"></el-table-column>
                <el-table-column min-width="50px" prop="audio_name" label="Name"></el-table-column>
                <el-table-column min-width="120px" label="Q&A">
                    <template slot-scope="scope">
                        <div style="height:40px">
                            <template v-if="scope.row.QA>0 && scope.row.QA<5">
                                <div>
                                    <div style="width: 100px;float: left">active:</div>
                                    <template v-if="scope.row.options[0]==1">
                                        <div class="style1" style="background-color: yellow"></div>
                                    </template>
                                    <template v-if="scope.row.options[1]==1">
                                        <div class="style1" style="background-color: red"></div>
                                    </template>
                                    <template v-if="scope.row.options[2]==1">
                                        <div class="style1" style="background-color: green"></div>
                                    </template>
                                    <template v-if="scope.row.options[3]==1">
                                        <div class="style1" style="background-color: blue"></div>
                                    </template>
                                </div>
                                <br>
                                <div>
                                    <div style="width: 100px;float: left">Correct button:</div>
                                    <template v-if="scope.row.QA==1">
                                        <div class="style1" style="background-color: yellow"></div>
                                    </template>
                                    <template v-if="scope.row.QA==2">
                                        <div class="style1" style="background-color: red"></div>
                                    </template>
                                    <template v-if="scope.row.QA==3">
                                        <div class="style1" style="background-color: green"></div>
                                    </template>
                                    <template v-if="scope.row.QA==4">
                                        <div class="style1" style="background-color: blue"></div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="120px" label="Conten Engagement">
                    <template slot-scope="scope">
                        <div style="height:40px">
                            <template v-if="scope.row.QA==8">
                                <div>
                                    <div style="width: 100px;float: left">active:</div>
                                    <template v-if="scope.row.options[0]==1">
                                        <div class="style1" style="background-color: yellow"></div>
                                    </template>
                                    <template v-if="scope.row.options[1]==1">
                                        <div class="style1" style="background-color: red"></div>
                                    </template>
                                    <template v-if="scope.row.options[2]==1">
                                        <div class="style1" style="background-color: green"></div>
                                    </template>
                                    <template v-if="scope.row.options[3]==1">
                                        <div class="style1" style="background-color: blue"></div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="150px">
                    <template slot-scope="scope">
                        <audio :src="scope.row.audio_url" controls></audio>
                    </template>
                </el-table-column>
                <el-table-column min-width="120px" label="Operator">
                    <template slot-scope="scope">
                            <div class="form-inline">
                                <a @click="toUpdate('/crafties/content/update',scope.row)"><i class="el-icon-s-data update"></i>Update</a>
                                <a @click="toDelete(scope.row)"><i class="el-icon-delete delete"></i>Delete</a>
                            </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
        title="Update Charter"
        :visible.sync="updateVisible"
        v-if="updateVisible"
        :close-on-click-modal="false"
        @close="closeUpdate"
        destroy-on-close
        top="10vh"
        width="550px"
        >
            <CraftiesContentUpdate @closeUpdate="closeUpdate($event)" :isQA="chooseItem.is_qa"></CraftiesContentUpdate>
        </el-dialog>
        <el-dialog
        title="Add Charter"
        :visible.sync="addVisible"
        v-if="addVisible"
        destroy-on-close
        top="10vh"
        width="550px"
        :close-on-click-modal="false"
        >
            <CraftiesContentCreate @closeAdd="closeAdd($event)" :isQA="chooseItem.is_qa"></CraftiesContentCreate>
        </el-dialog>
        <el-dialog
        title="Batch Upload Audio"
        :visible.sync="uploadVisible"
        v-if="uploadVisible"
        destroy-on-close
        top="10vh"
        width="400px"
        :close-on-click-modal="false"
        >
            <CraftiesContentZipUpload @closeUpload="closeUpload($event)" :language="search.language" :chooseItem="chooseItem"></CraftiesContentZipUpload>
        </el-dialog>
    </div>
</template>

<script>
    import Sortable from 'sortablejs'
    import CraftiesContentCreate from './CraftiesContentCreate'
    import CraftiesContentUpdate from './CraftiesContentUpdate'
    import CraftiesContentZipUpload from './CraftiesContentZipUpload'

    export default {
        components: {
            CraftiesContentZipUpload, Sortable, CraftiesContentCreate, CraftiesContentUpdate
        },
        data () {
            return {
                list: [],
                search: {
                    language: 1,
                    languageCode: 'EN',
                    crafite_uuid: ''
                },
                ceCounts: {},
                chooseItem: null,
                version: 0,
                total: 0,
                pageIndex: 1,
                pageSize: 20,
                addVisible: false,
                updateVisible: false,
                uploadVisible:false,
                height: 80,
                flag: true,
            }
        },
        created () {
            this.chooseItem = this.$util.fetch('craftiesContent')
            this.search.crafite_uuid = this.chooseItem.crafite_uuid
            this.getData()
        },
        mounted () {},
        computed: {},
        methods: {
            getData (f=null) {
                this.search.size = this.pageSize
                this.search.page = this.pageIndex
                console.log(this.pageSize,this.pageIndex)
                if(this.total!=0){
                    this.search.size =this.pageSize*this.pageIndex
                    this.search.page =1
                }
                this.flag = false
                this.$api.rootV1.post('/web/playlist/audio/list', this.search, (res) => {
                    this.flag = true
                    if(f!=null)
                        f()
                    this.$nextTick(() => {
                        let count = 0;
                        let ceCounts = {};
                        for (let i = 0; i < res.data.length; i++) {
                            const front = count ;
                            if(res.data[i].QA == 8){
                                ++count;
                            }
                            ceCounts[i] = {front, back: count}
                        }

                        this.ceCounts = ceCounts;
                        this.list = res.data
                        this.total = res.totalCount
                        this.version = res.version
                        const table = document.querySelector('.el-table__body-wrapper tbody')
                        const self = this
                        Sortable.create(table, {
                            draggable: '.el-table__row',
                            onEnd (el) {
                                if (el.oldIndex == el.newIndex) {
                                    return
                                }

                                const currentAudio = self.list.filter((row) => row.show_charter_no == el.oldIndex + 1)[0];
                                const from = self.ceCounts[el.oldIndex].front * 4 + el.oldIndex + 1
                                let to = 0
                                if (el.oldIndex > el.newIndex) {
                                    // 上移
                                    to = self.ceCounts[el.newIndex].front * 4 + el.newIndex + 1
                                } else {
                                    to = self.ceCounts[el.newIndex].back * 4 + el.newIndex + 1
                                }

                                console.log(from,to,currentAudio.audio_id)
                                // return

                                self.$api.rootV1.post('/web/playlist/audio/move',
                                    {
                                        audio_id: currentAudio.audio_id,//self.list[el.oldIndex].audio_id,
                                        from,
                                        to,
                                        search: self.search
                                    }, 
                                    (res) => {
                                        let count = 0;
                                        let ceCounts = {};
                                        for (let i = 0; i < res.data.length; i++) {
                                            const front = count ;
                                            if(res.data[i].QA == 8){
                                                ++count;
                                            }
                                            ceCounts[i] = {front, back: count};
                                            const idx = self.list.findIndex((item) => item.audio_id ==res.data[i].audio_id )
                                            self.list[idx].charter_no = res.data[i].charter_no;
                                            self.list[idx].show_charter_no = res.data[i].show_charter_no;
                                        }
                                    },
                                    () => {
                                        self.$message.error('failure!')
                                    }
                                )
                            }
                        })

                    })
                })
            },
            toEnglish () {
                if (this.search.languageCode != 'EN') {
                    let loading=this.$util.loading()
                    this.$refs.english.classList.remove('inactive')
                    this.$refs.spanish.classList.remove('activation')
                    this.$refs.english.classList.add('activation')
                    this.$refs.spanish.classList.add('inactive')
                    this.search.language = 1
                    this.pageIndex=1
                    this.search.languageCode = 'EN'
                    this.getData()
                    loading.close()
                }
            },
            toSpanish () {
                if (this.search.languageCode != 'ES') {
                    let loading=this.$util.loading()
                    this.$refs.spanish.classList.remove('inactive')
                    this.$refs.english.classList.remove('activation')
                    this.$refs.spanish.classList.add('activation')
                    this.$refs.english.classList.add('inactive')
                    this.search.language = 2
                    this.pageIndex=1
                    this.search.languageCode = 'ES'
                    this.getData()
                    loading.close()
                }
            },
            toAdd () {
                this.chooseItem.language = this.search.language
                this.$util.save('item', Object.assign(this.chooseItem, {total: this.total}))
                this.addVisible = true
            },
            closeAdd (flag) {
                this.$util.delete('item')
                if(flag){
                    this.getData(()=>this.addVisible = false)
                }else {
                    this.addVisible = false
                }
            },
            closeUpload (flag=false) {
                if(flag){
                    this.getData(()=>this.uploadVisible = false)
                }else {
                    this.uploadVisible = false
                }
            },
            toUpdate (path, row) {
                this.chooseItem.language = this.search.language
                this.$util.save('item', Object.assign(this.chooseItem, {total: this.total}))
                this.$util.save('item1', row)
                this.$util.save('ceCounts', this.ceCounts)
                this.$util.save('listlength', this.list.length)
                this.updateVisible = true
            },
            closeUpdate (flag) {
                if(flag){
                    this.getData(()=>this.updateVisible = false)
                }else {
                    this.updateVisible = false
                }
                this.$util.delete('item')
                this.$util.delete('item1')
            },
            toDelete (row) {
                this.$confirm('This operation will delete the charter, do you want to continue?', 'prompt', {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(async () => {
                    let loading=this.$util.loading()
                    this.doDelete(row)
                    loading.close()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'cancelled!'
                    })
                })
            },
            doDelete (row) {
                this.$api.rootV1.post('/web/playlist/audio/delete', {audio_id: row.audio_id}, (res) => {
                    this.$message.success('successfully deleted!')
                    this.getData()
                }, (res) => {
                    this.$message.error('failed to delete!')
                })
            },
            loadMore () {
                if (this.pageIndex * this.pageSize >= this.total) {
                    return this.$message.success({message: 'All data has been loaded!', duration: 1000})
                }
                this.search.size = this.pageSize
                this.search.page = ++this.pageIndex
                this.$api.rootV1.post('/web/playlist/audio/list', this.search, (res) => {
                    this.list.splice(this.list.length, 0, ...res.data)
                    this.total = res.totalCount
                    this.version = res.version
                },(res)=>{})
            },
            sortByNo (o1, o2) {
                return o1.charter_no - o2.charter_no
            }
        }
    }
</script>

<style scoped>
    .style1 {
        width: 15px;
        height: 15px;
        display: flex;
        float: left;
        margin-left: 5px;
        margin-top: auto;
        margin-bottom: auto;
    }

    .activation {
        border: none;
        background: none;
        margin-left: 5px;
        color: deepskyblue;
        text-decoration: underline deepskyblue;
    }

    .inactive {
        border: none;
        background: none;
        margin-left: 5px;
        color: black;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/crafties/CraftiesContent.vue